import React from 'react'
import '../../styles.css'

export const HeroSection = () => {
    return (
        <div className="hero-bg">
        </div>
    )
}
